import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

function ListadoKardex() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS = `${process.env.REACT_APP_URL_INVENTARIOS}`;
  const URL_SEGUIMIENTOS = `${process.env.REACT_APP_URL_SEGUIMIENTOS}`;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;

  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [value, setValue] = useState("");
  const [articuloNombre, setArticuloNombre] = useState("");
  // Articulo elegido (objeto). Si es MASTER el kardex junta los movimientos de todas sus variantes
  const [articuloSel, setArticuloSel] = useState(null);
  const esMasterSel = !!articuloSel && articuloSel.modelo === "MASTER";
  // Que lista el buscador: "masters" (masters y articulos sin master), "variantes" o "todos"
  const [vista, setVista] = useState("masters");

  const [existenMovs, setExistenMovs] = useState(true);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");
    const [cargando, setCargando] = useState(true);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  // Variantes de un master (las que lo tienen como articuloPadre)
  const variantesDe = (m) =>
    articulos.filter(
      (a) => String((a.articuloPadre && a.articuloPadre._id) || a.articuloPadre || "") === String(m._id)
    );

  // Movimientos del articulo en el almacen. Con un MASTER: los de todas sus variantes (y los del propio
  // master, por si trae historial), con la cantidad en unidades del master (cantidad x piezasPorCaja) y
  // la existencia en esas unidades.
  function cargarKardex(sel, area) {
    if (!sel || !sel._id || !area) return;
    setCargando(true); // Activa el estado de carga desde el inicio
    const Toast = Swal.mixin({
      toast: true,
      position: "center",
      showConfirmButton: false,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });
    // Muestra el Toast de carga
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`,
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
    setComments([]);

    const esMaster = sel.modelo === "MASTER";
    const lista = esMaster ? [sel, ...variantesDe(sel)] : [sel];
    const factorDe = (art) =>
      esMaster && art.modelo !== "MASTER" ? parseFloat(art.piezasPorCaja) || 1 : 1;

    Promise.all(
      lista.map((art) =>
        axios
          .get(`${URL_SEGUIMIENTOS}Kardex/${art._id}/${area}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((response) =>
            (response.data || []).map((m) => ({
              ...m,
              SKU: art.modelo === "MASTER" && esMaster ? `${art.SKU} (master)` : art.SKU,
              factor: factorDe(art),
            }))
          )
      )
    )
      .then((listas) => {
        // De mas antiguo a mas nuevo para el calculo de existencia. Los renglones en 0 (notas canceladas,
        // ajustes anulados) no mueven la existencia: no se muestran.
        const movs = [].concat(...listas).filter((m) => (parseFloat(m.cantidad) || 0) !== 0).sort((a, b) =>
          a.fecha !== b.fecha
            ? a.fecha > b.fecha ? 1 : -1
            : String(a.createdAt) > String(b.createdAt) ? 1 : -1
        );
        let existencia = 0;
        const arrayTabla = movs.map((a) => {
          const piezas = (parseFloat(a.cantidad) || 0) * a.factor;
          existencia += piezas;
          return {
            fecha: a.fecha,
            createdAt: a.createdAt,
            tipoMov: a.tipoMov,
            numMov: a.numMov,
            destino: a.destino,
            SKU: a.SKU,
            factor: a.factor,
            cantidad: a.cantidad,
            piezas,
            existencia,
          };
        });
        // De mas nuevo a mas antiguo para presentacion
        arrayTabla.sort((a, b) =>
          a.fecha !== b.fecha
            ? a.fecha < b.fecha ? 1 : -1
            : String(a.createdAt) < String(b.createdAt) ? 1 : -1
        );
        setComments(arrayTabla);
        setExistenMovs(arrayTabla.length > 0);
        setCargando(false);
        Swal.close(); // Cierra el toast
      })
      .catch((err) => {
        console.log(err);
        setCargando(false);
        Swal.close(); // Cierra el toast incluso si hay error
      });
  }

  function BuscaArticulo(sel) {
    if (!sel || !sel._id) return;
    const esMaster = sel.modelo === "MASTER";
    setArticuloSel(sel);
    setArticuloNombre(
      `${sel.SKU} - ${sel.nombre}${esMaster ? ` (MASTER: ${variantesDe(sel).length} variante(s))` : ""}`
    );
    setValue(sel._id);
    setCurrentPage(1);
    cargarKardex(sel, selectedArea);
  }

  function BuscaArea(event) {
    setSelectedArea(event.target.value);
    setComments([]);
    setCurrentPage(1);
    cargarKardex(articuloSel, event.target.value);
  }

  function PDFTabla() {
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 137, 15, 45, 15);
    doc.text(`${articuloNombre || ""}`.slice(0, 90), 20, 35);
    doc.text(`Kardex`, 20, 40);
    const n2 = (x) => new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(x);
    const data2 = comments.map((a) => {
      return esMasterSel
        ? [a.fecha, a.tipoMov, a.numMov, a.destino, a.SKU, n2(a.cantidad), n2(a.piezas), n2(a.existencia)]
        : [a.fecha, a.tipoMov, a.numMov, a.destino, n2(a.cantidad), n2(a.existencia)];
    });
    const dataPDF2 = Object.values(data2);
    const dataPDFLimpia2 = dataPDF2.filter(function (el) {
      return el != null;
    });
    doc.autoTable({
      head: [
        esMasterSel
          ? ["Fecha", "Movimiento", "Numero", "Cliente/Prov", "Variante", "Cantidad", "Unidades master", "Existencia (master)"]
          : ["Fecha", "Movimiento", "Numero", "Cliente/Prov", "Cantidad", "Existencia"],
      ],
      body: dataPDFLimpia2,
      startY: 45,
      footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [["", "", "", "", ""]],
      showFoot: "lastPage",
    });

    //////
    doc.save(`Kardex.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      return {
        Fecha: a.fecha,
        Movimiento: a.tipoMov,
        Numero: a.numMov,
        Destino: a.destino,
        Variante: a.SKU,
        Cantidad: a.cantidad,
        UnidadesMaster: a.piezas,
        Existencia: a.existencia,
      };
    });
    const columnas = esMasterSel
      ? ["Fecha", "Movimiento", "Numero", "Destino", "Variante", "Cantidad", "UnidadesMaster", "Existencia"]
      : ["Fecha", "Movimiento", "Numero", "Destino", "Cantidad", "Existencia"];
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoKardex";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoKardex",
        sheetFilter: columnas,
        sheetHeader: columnas,
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 137, 15, 45, 15);
    doc.text(`${articuloNombre || ""}`.slice(0, 90), 20, 35);
    doc.text(`Kardex`, 20, 40);
    const n2 = (x) => new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(x);
    const data2 = comments.map((a) => {
      return esMasterSel
        ? [a.fecha, a.tipoMov, a.numMov, a.destino, a.SKU, n2(a.cantidad), n2(a.piezas), n2(a.existencia)]
        : [a.fecha, a.tipoMov, a.numMov, a.destino, n2(a.cantidad), n2(a.existencia)];
    });
    const dataPDF2 = Object.values(data2);
    const dataPDFLimpia2 = dataPDF2.filter(function (el) {
      return el != null;
    });
    doc.autoTable({
      head: [
        esMasterSel
          ? ["Fecha", "Movimiento", "Numero", "Cliente/Prov", "Variante", "Cantidad", "Unidades master", "Existencia (master)"]
          : ["Fecha", "Movimiento", "Numero", "Cliente/Prov", "Cantidad", "Existencia"],
      ],
      body: dataPDFLimpia2,
      startY: 45,
      footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [["", "", "", "", ""]],
      showFoot: "lastPage",
    });

    //////

    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Kardex",
          email: mailTo,
          fileName: "ListadoKardex.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el seguimineto al articulo.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = esMasterSel
    ? [
        { name: "Fecha", field: "fecha", sortable: false },
        { name: "Movimiento", field: "tipoMov", sortable: false },
        { name: "Numero", field: "numMov", sortable: false },
        { name: "Cliente / Proveedor", field: "destino", sortable: false },
        { name: "Variante", field: "SKU", sortable: false },
        { name: "Cantidad", field: "cantidad", sortable: false },
        { name: "Unidades master", field: "piezas", sortable: false },
        { name: "Existencia (master)", field: "existencia", sortable: false },
      ]
    : [
        { name: "Fecha", field: "fecha", sortable: false },
        { name: "Movimiento", field: "tipoMov", sortable: false },
        { name: "Numero", field: "numMov", sortable: false },
        { name: "Cliente / Proveedor", field: "destino", sortable: false },
        { name: "Cantidad", field: "cantidad", sortable: false },
        { name: "Existencia", field: "existencia", sortable: false },
      ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          String(comment.destino || "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.tipoMov || "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.SKU || "").toLowerCase().includes(search.toLowerCase())
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting]);

  const esVariante = (a) => a.modelo !== "MASTER" && !!a.articuloPadre;
  const options = articulos
    .filter((a) => vista === "todos" || (vista === "variantes" ? esVariante(a) : !esVariante(a)))
    .map((option) => {
    const junta = option.SKU + option.nombre + (option.modelo === "MASTER" ? " MASTER" : "");
    const firstLetter = option.SKU[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  let existencia = 0;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.seguimiento_inventarios ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {/* <Button
                size="sm"
                href="/MenuInventarios"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button> */}
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Disponible</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Kardex</h3>

          <Row>
            <Col md={2}>
              <Label>Almacen</Label>
              <Input
                // bsSize="sm"
                type="select"
                value={selectedArea}
                required
                onChange={(e) => {
                  BuscaArea(e);
                }}
              >
                <option value="">Selecciona</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            {selectedArea != "" ? (
              <>
                <Col md={2}>
                  <Label>Codigo</Label>
                  <Input
                    // bsSize="sm"
                    type="text"
                    value={value}
                    onChange={(e) => {
                      BuscaArticulo(e);
                      setCurrentPage(1);
                    }}
                  ></Input>
                </Col>
                <Col md={2}>
                  <Label>Ver</Label>
                  <Input type="select" value={vista} onChange={(e) => setVista(e.target.value)}>
                    <option value="masters">Solo masters</option>
                    <option value="variantes">Solo variantes</option>
                    <option value="todos">Todos</option>
                  </Input>
                </Col>
                <Col md={2}>
                  <Label>Buscar</Label>
                  <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedArticulo) => {
                      BuscaArticulo(selectedArticulo);
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.modelo === "MASTER" && (
                          <span style={{ background: "#ec4899", color: "#fff", fontSize: "0.6rem", padding: "1px 5px", borderRadius: 3, marginRight: 4, fontWeight: 700 }}>
                            MASTER
                          </span>
                        )}
                        {option.SKU} {option.nombre}
                      </React.Fragment>
                    )}
                  />
                </Col>
                <Col md={4}>
                  <Label>Articulo</Label>
                  <Input
                    name="articulo"
                    type="string"
                    placeholder="Articulo"
                    value={articuloNombre}
                    disabled
                  />
                </Col>
              </>
            ) : undefined}
          </Row>
          <br />

          <Row>
            <div className="col-md-6 d-flex flex-row-reverse" id="logoutBoton">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </Row>

          <br />

          {/* Tabla Movimientos */}
          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />

          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />

            <tbody>
              {existenMovs ? (
                commentsData
                .sort((a, b) => {
    if (a.fecha < b.fecha) return 1;
    if (a.fecha > b.fecha) return -1;
    // Si las fechas son iguales, ordenar por createdAt
    if (a.createdAt < b.createdAt) return 1;
    if (a.createdAt > b.createdAt) return -1;
    return 0;
  })
                .map((a) => {
                  // existencia = parseFloat(existencia) + parseFloat(a.cantidad);
                  return (
                    <tr>
                      <td>{a.fecha}</td>
                      <td>{a.tipoMov}</td>
                      <td>{a.numMov}</td>
                      <td>{a.destino}</td>
                      {esMasterSel && <td>{a.SKU}{a.factor !== 1 ? ` (×${a.factor})` : ""}</td>}
                      <td>
                        {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.cantidad)}
                      </td>
                      {esMasterSel && (
                        <td>
                          {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.piezas)}
                        </td>
                      )}
                      <td>
                        {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.existencia)}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td></td>
                  <td></td>
                  <td>No se encontraron Movimientos...</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}

      {loader}
    </>
  );
}

export default ListadoKardex;
